import animateSwitcher from "../../scripts/animateSwitcher";
import Velocity from "velocity-animate";

export default {
	data() {
		return {
			bankingSupportNavTabs: 'about',
            bankingSupportDocsTabSwitch: 'docs',
			switcherChecker: false,
		};
	},
	updated() {
		if (this.bankingSupportNavTabs === 'docs' && this.switcherChecker === false) {
			this.switcherChecker = true;
			animateSwitcher();
		} else if(this.bankingSupportNavTabs !== 'docs') {
			this.switcherChecker = false;
		}
	},
	methods: {
		selectBankingSupportTab(tab) {
			this.bankingSupportNavTabs = tab;
			window.scrollTo(0, 0);
		},
		bankingSupportForm() {
			if (this.bankingSupportNavTabs === 'docs') this.bankingSupportNavTabs = 'about';

			this.$nextTick(() => {
				const el = document.getElementById('form');
				if (!el) return;

				Velocity(
					el,
					'scroll',
					{
						duration: 800,
						offset: -el.offsetHeight / 3,
					}
				);
			})
		},
	},
};
